export default {
  // red
  redDark: '#BF0E08',
  redBase: '#EC4C47',
  redLight: '#FAE2E2',
  redLightest: '#FEF6F6',
  alzarain: '#eb4d4b',
  // orange
  orangeDark: '#95591E',
  orangeBase: '#D9822B',
  orangeLight: '#FAE3CD',
  orangeLightest: '#FDF8F3',
  // green
  greenDark: '#00783E',
  greenBase: '#47B881',
  greenLight: '#D4EEE2',
  greenLightest: '#F1FAF5',
  // blue
  blueDark: '#084B8A',
  blueBase: '#1070CA',
  blueLight: '#084B8A',
  blueLightest: '#F6F9FD',
  bluePrimary: '#095bfc',
  // white
  whiteCloud: '#fafbfb',
  // black
  black: '#2f2f2f',
  black7: '#E0E0E0',
  black6: '#C1C1C1',
  black5: '#A8A8A8',
  black4: '#8F8F8F',
  black3: '#767676',
  black2: '#4F4F4F',
  black1: '#262626',
  // brown
  brown: '#d6d9e1',
  brownDark: '#ececec',
  grey: '#fafafa',
  white: '#fff',
  aliceBlue: '#f3f6f9',
  solitude: '#e5e7ec',
};
